import { Spacings4 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const AlertWrapper = css({
  marginTop: Spacings4,
  marginBottom: Spacings4,
  '& .MuiAlert-message': {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

const RemainingTimeStyle = {
  AlertWrapper,
};

export default RemainingTimeStyle;
